import React from 'react';

const Header = (props) => {
    return (
        <header>
            <div className="headerComponent">
                <h1>poke <span>adopt</span></h1>
                <p>Choose pokemon to adopt then sign adoption papers</p>
            </div>
            <img className="headerImage" src={require("../assets/ashPikachu.png")} alt=""/>
        </header>
    )
};

export default Header;